var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHelpActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "12.574px",
    height: "21.014px",
    viewBox: "0 0 12.574 21.014",
    enableBackground: "new 0 0 12.574 21.014",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_309",
    transform: "translate(-1875.082 -1604.969)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_308",
    transform: "translate(1875.332 1605.22)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_6509"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#cc0e2d",
    d: "M5.907,14.976c-0.24-0.01-0.47-0.12-0.64-0.3c-0.16-0.18-0.25-0.41-0.24-0.66c0-0.04,0.01-0.08,0.02-0.16 c0.08-1.81,1.12-3.47,2.721-4.32c0.92-0.47,1.6-1.27,1.92-2.24c0.319-0.98,0.239-2.02-0.23-2.94c-0.66-1.3-1.979-2.11-3.43-2.11 c-0.61,0-1.2,0.14-1.75,0.42c-1.21,0.62-2.01,1.84-2.09,3.19c-0.03,0.49-0.2,1.09-0.82,1.19c-0.54,0.07-1.03-0.3-1.11-0.82 c-0.01-0.07-0.01-0.15-0.01-0.23c0.05-2.33,1.48-4.38,3.63-5.22c0.71-0.22,1.45-0.39,2.13-0.53c2.53,0.1,4.75,1.78,5.51,4.2 c0.76,2.51-0.28,5.21-2.5,6.56c-1.211,0.56-2,1.73-2.061,3.07c-0.03,0.51-0.44,0.899-0.95,0.899"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_6510"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#cc0e2d",
    d: "M7.347,18.816v0.08c0.011,0.36-0.119,0.7-0.359,0.96c-0.24,0.261-0.57,0.41-0.93,0.42l-0.05,0.25v-0.25 c-0.72,0-1.3-0.569-1.33-1.289v-0.07c-0.01-0.351,0.12-0.69,0.36-0.95s0.57-0.42,0.98-0.43 C6.737,17.536,7.317,18.106,7.347,18.816z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpActive);
export default __webpack_public_path__ + "static/media/HelpActive.95b2cdfd2c9b393d91ae5bd2aac7a053.svg";
export { ForwardRef as ReactComponent };